/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

var cartDrawerCheckoutButton = document.querySelector(".cart-drawer__checkout");
var cartDrawerAgeCheckbox = document.querySelector(
  ".cart-drawer__age-checkbox"
);
var cartCheckoutButton = document.querySelector(".cart__checkout-btn");
var cartAgeCheckbox = document.querySelector(".cart__age-checkbox");

// uncheck checkbox on page load to force selection
document.addEventListener("DOMContentLoaded", function () {
  if (cartDrawerAgeCheckbox) {
    cartDrawerAgeCheckbox.checked = false;
  }
  if (cartAgeCheckbox) {
    cartAgeCheckbox.checked = false;
  }
});

if (cartDrawerAgeCheckbox) {
  cartDrawerAgeCheckbox.addEventListener("click", function () {
    if (cartDrawerAgeCheckbox.checked) {
      cartDrawerCheckoutButton.disabled = false;
    } else {
      cartDrawerCheckoutButton.disabled = true;
    }
  });
}

if (cartAgeCheckbox) {
  cartAgeCheckbox.addEventListener("click", function () {
    if (cartAgeCheckbox.checked) {
      cartCheckoutButton.disabled = false;
    } else {
      cartCheckoutButton.disabled = true;
    }
  });
}
